import { ReactComponent as CrawlIcon } from "assets/svgs/robot/modes/Crawl.svg";
import { ReactComponent as SitIcon } from "assets/svgs/robot/modes/Sit.svg";
import { ReactComponent as StairIcon } from "assets/svgs/robot/modes/Stair.svg";
import { ReactComponent as StandIcon } from "assets/svgs/robot/modes/Stand.svg";
import { ReactComponent as WalkIcon } from "assets/svgs/robot/modes/Walk.svg";

import { ROBOT_POSITION_TOPIC, TOPIC_NAV_STATE } from "arcjs/state";
import { Pose } from "arcjs/common/geometry";

export const DefaultEnableControl = true;

// Motor power
export const MotorPowerState = {
    POWER_OFF: "POWER_OFF",
    POWER_ON: "POWER_ON",
    POWERED_OFF: "POWERED_OFF",
    POWERED_ON: "POWERED_ON",
    POWERING_OFF: "POWERING_OFF",
    POWERING_ON: "POWERING_ON",
    ERROR: "ERROR",
    UNKNOWN: "UNKNOWN",
};

// Mode
export const RobotModeIcons = {
    SIT: <SitIcon className="w-6" />,
    STAND: <StandIcon className="w-6" />,
    WALK: <WalkIcon className="w-6" />,
    STAIR: <StairIcon className="w-6" />,
    CRAWL: <CrawlIcon className="w-6" />,
    // Lynx agile gaits (advertised on /state/modes)
    FLAT_AGILE: <WalkIcon className="w-6" />,
    STAIR_AGILE: <StairIcon className="w-6" />,
};

// Height
// -> cm
export const DefaultHeight = 0.0;
export const DefaultMinHeight = 0.0;
export const DefaultMaxHeight = 30.0;

export type StateInfo = {
    [key: string]: {
        topic: string;
        default: any;
    };
};

export const robotStatesInfo = {
    battery: {
        topic: "/state/battery",
        default: null,
    },
    motorPower: {
        topic: "/state/motor",
        default: MotorPowerState.POWERED_OFF,
    },
    modes: {
        topic: "/state/modes",
        default: ["SIT", "STAND", "WALK"],
        // `/state/modes` is a std_msgs/String carrying a JSON array (e.g. the
        // go2_webrtc_control bridge publishes '["SIT","STAND","WALK"]'). arcjs
        // unwraps it to a plain string, so normalise back to an array here —
        // ModeBar does `modes.map(...)`. Tolerate a bare string, a JSON array
        // string, or an already-parsed array.
        transform: (value: unknown): string[] => {
            if (Array.isArray(value)) return value as string[];
            if (typeof value === "string") {
                try {
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) return parsed as string[];
                } catch {
                    // not JSON — treat as a single mode name
                }
                return [value];
            }
            return [];
        },
    },
    mode: {
        topic: "/state/mode",
        default: "SIT",
    },
    height: {
        topic: "/state/height",
        default: 0.0,
    },
};

type NavComponentState = "START" | "STOP";

export type NavigationState = {
    navState: {
        nav: NavComponentState;
        map: NavComponentState;
        slam: NavComponentState;
    };
    robotPose: Pose | undefined;
};

export type NavigationStateInfoType = {
    [key in keyof NavigationState]: {
        topic: string;
        default: NavigationState[key];
    };
};

export const navigationStateInfo: NavigationStateInfoType = {
    navState: {
        topic: TOPIC_NAV_STATE,
        default: { nav: "STOP", map: "STOP", slam: "STOP" },
    },
    robotPose: {
        topic: ROBOT_POSITION_TOPIC,
        default: undefined,
    },
};
